import React, { Fragment } from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
export const Marquee = () => {
  const {
    lang
  } = useLanguage();
  const items = translations[lang].marquee;
  const MarqueeContent = () => <div className="flex items-center justify-around w-1/2 min-w-max px-4" data-id="element-161" data-mp="2ijxes9qnqd50">
      {items.map((item, index) => <Fragment key={index} data-id="element-162" data-mp="2diq5254yf3vp" data-mpi={index}>
          <span className="font-serif-cormorant italic text-xl md:text-2xl text-[#1a1a1a] px-8 whitespace-nowrap" data-id="element-163" data-mp="3b8uss0nu5nry">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#c9a96e] flex-shrink-0" data-id="element-164" data-mp="36a1hmew0u8uy" />
        </Fragment>)}
    </div>;
  return <div className="w-full bg-[#f8f4ef] py-6 overflow-hidden border-b border-[#c9a96e]/20" data-id="element-165" data-mp="2x8tsonfeakdj">
      <div className="flex w-[200%] animate-marquee" data-id="element-166" data-mp="1pv06mzg5twpz">
        <MarqueeContent data-id="element-167" data-mp="1pwjnos9n4bst" />
        <MarqueeContent data-id="element-168" data-mp="1psvuju83xrem" />
      </div>
    </div>;
};